import { useMemo } from 'react';

import { useCategoryTreeConversion } from '../../category-tree';
import { type SelectedSchoolInfo, type SubjectTree } from '../types';

/**
 * 과목 노드 목록 조회 hook
 * @param selectedSchoolInfo - 선택된 학교 정보
 * @param subjectTree - 과목 트리
 * @returns 과목 노드 목록
 */
export const useSubjectNodeList = ({
  selectedSchoolInfo,
  subjectTree,
}: {
  subjectTree: SubjectTree;
  selectedSchoolInfo: SelectedSchoolInfo;
}) => {
  const { convertTree } = useCategoryTreeConversion();
  const { schoolTypeNode, gradeNode } = selectedSchoolInfo;

  const subjectNodeParentId = useMemo(() => {
    if (gradeNode) return gradeNode.nodeId;

    return schoolTypeNode?.nodeId;
  }, [schoolTypeNode, gradeNode]);

  return useMemo(() => {
    if (!subjectNodeParentId) return undefined;

    const filteredSubjectNodes = subjectTree.filter(
      node => node.ancestors?.includes(subjectNodeParentId),
    );

    return convertTree(filteredSubjectNodes);
  }, [subjectTree, convertTree, subjectNodeParentId]);
};
